import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for local development
 *
 * Don't edit this file to point your own dev server elsewhere — set the matching
 * `VITE_LOCAL_*_SERVER` variable in a git-ignored `.env.local` file instead (see `.env.example`)
 *
 * @see {@link file://./../local-server-overrides.ts}
 */
export const developmentServerConfig: ServerBaseUrl = {
    apiServer: 'http://localhost:8002',
    auroraApiServer: 'https://dev.aurora-v2.wisesys.info',
    initialVsActualServer:
        'https://l8e0mz5odb.execute-api.us-east-1.amazonaws.com/uat',
    equipment: 'https://services-uat.us.wisesys.info',
    socketServer: 'ws://localhost:1037',
    equipmentSocketServer: 'wss://equipmentsocket-uat.us.wisesys.info',
    environment: ServerEnvironment.UAT,
    CIEnv: ServerCIEnvironment.UAT,
    vehicleProfile: 'http://localhost:8020',
    routePathGeometryServer:
        'https://u0dlfowfi9.execute-api.us-east-1.amazonaws.com/uat',
    configurableWorkflowServer:
        'https://ksjgorzu2k.execute-api.us-east-1.amazonaws.com/Prod',
    auroraServer: 'https://dev-api.aurora-v2.wisesys.info',
    driverCostServer: 'http://localhost:3010',
    bannerService: 'https://tp3ei4l6wg.execute-api.us-east-1.amazonaws.com/dev'
};
